import { useTranslation } from "react-i18next";
import { useApp } from "context/app";
import Select from "components/form/Select";
import Calendar from "components/Calendar";

const InvoiceFilters = ({ values, onChange }) => {
  const { t } = useTranslation();
  const { websites = [] } = useApp();
  const options = [
    { label: t("All websites"), value: null },
    ...websites.map(({ _id, website }) => ({ label: website, value: _id })),
  ];

  return (
    <>
      <Select
        key={values.website || "all"}
        label={t("Website")}
        options={options}
        value={websites.length === 1 ? websites[0]._id : values.website || null}
        disabled={websites.length === 1}
        forceBottom
        onChange={(option) => onChange("website", option?.value)}
      />
      <Calendar
        key={`start-${values.start_date || "empty"}`}
        label={t("Start date")}
        default_value={values.start_date}
        next_date={values.end_date}
        onChange={(value) => onChange("start_date", value)}
      />
      <Calendar
        key={`end-${values.end_date || "empty"}`}
        label={t("End date")}
        default_value={values.end_date}
        prev_date={values.start_date}
        onChange={(value) => onChange("end_date", value)}
      />
    </>
  );
};

export default InvoiceFilters;